<template>
  <div class="info-display">

    <NUIColorDot v-if="icon === 'Nozzle' || icon === 'Plate'" select="nozzles" :forceColor="getColorValue" class="pdh-color-dot"/>

    <div v-if="icon === 'Pressure'" class="pressure-label pdh-icon">
      <b>&Delta;P</b>
    </div>

    <div v-if="icon === 'Flow'" class="flow-label pdh-icon">
      <b>&Delta;Q</b>
    </div>

    <div class="id-value-holder">
      <div class="id-label">{{label}}</div>
      <div class="value-display">
        <div class="id-value">{{getValue}}</div>
        <div class="id-unit">{{unit}}</div>
      </div>
    </div>

  </div>
</template>

<script>

import NUIColorDot from '@/components/nelsonUI/NUIColorDot.vue';

export default {
  name: 'PDHInfoDisplay',
  components: {
    NUIColorDot
  },
  props: [
  'label',
  'value',
  'unit',
  'icon'
  ],
  computed: {
    getValue () {

      if (this.label === 'Plate') {
       return this.value.replace(/['"]+/g, '');
      }

      if (this.label === 'Nozzle') {
        return this.value.replace(/^#?\d+\s*/, '').replace(/\s*NOZZLE$/, '');
      }

      if (isNaN(this.value)) {
        return this.value;
      }
      return Number.parseFloat(this.value).toFixed(2);
    },

    getColorValue () {

      let value = this.getValue;
      return value.toLowerCase();

    }
  }
};
</script>

<style scoped>
.info-display {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  width: 100%;
  border-bottom: 1px solid lightgray;
  min-width: 120px;
}

.id-label {
  font-size: 14px;
  font-weight: 600;
}

.id-value {
  font-size: 18px;
  margin-top: -4px;
}

.id-value-holder {
  display: flex;
  align-items: baseline;
  flex-direction: column;
}

.id-unit {
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  padding-left: 6px;
}

.pressure-label {
  background-color: var(--pressure-color);
  border-radius: 25px;
  height: 100%;
  aspect-ratio: 1/1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}
.flow-label {
  background-color: var(--flow-color);
  height: 100%;
  aspect-ratio: 1/1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.pdh-icon {
  width: 32px;
  height: 32px;
}

.value-display {
  display: flex;
  align-items: baseline;
}

.pdh-color-dot {
  transform: translateY(8px);
}
</style>